import { loginRoute, registerRoute } from '@lessonup/typescript-core/services';
import { ActionButton, Modal, Text } from '@lessonup/typescript-core/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps, withRouter } from 'react-router';
// eslint-disable-next-line import/no-cycle -- auto-generated TECH-258
import { useAppServices } from '../../appServices/AppServicesContext';
import './LoginPromptModal.less';

const TRANSLATION_NAMESPACE = 'loginPromptModal';

export interface LoginPromptModalResult {
  dismiss?: boolean;
}

export type LoginPromptAction = 'save' | 'teach' | 'aiTools';

export interface LoginPromptConfig {
  forceNewTab?: boolean;
  action: LoginPromptAction;
}

type Props = RouteComponentProps &
  LoginPromptConfig & {
    closeModal: (res: LoginPromptModalResult | undefined) => void;
  };

function LoginPromptModal(props: Props) {
  const { t } = useTranslation(TRANSLATION_NAMESPACE);
  const { modals, user } = useAppServices();

  function handleClose(dismiss?: boolean) {
    return props.closeModal({ dismiss: !!dismiss });
  }

  async function handleLoginClick() {
    if (!props.forceNewTab) {
      const loginResult = await modals.open('login', { userService: user });
      return handleClose(loginResult.status === 'failed');
    }

    window.open(loginRoute('form'), '_blank');
    return handleClose(true);
  }

  async function handleRegisterClick() {
    if (!props.forceNewTab) {
      props.history.push(registerRoute(), '');
    } else {
      window.open(registerRoute('credentials'), '_blank');
    }
    return handleClose(true);
  }

  return (
    <Modal title={t('title')} isOpen onRequestClose={handleClose} width="medium">
      <div className="login-modal">
        <div className="loginmodal__header">
          <div className="loginmodal_headertext">
            <Text
              translateKey={
                props.action === 'teach'
                  ? 'descriptionTeach'
                  : props.action === 'aiTools'
                    ? 'descriptionAiTools'
                    : 'descriptionSave'
              }
              options={{ ns: TRANSLATION_NAMESPACE }}
            />
          </div>
        </div>
        <br />
        <div className="loginmodal-buttons">
          <ActionButton theme="secondary" onClick={handleLoginClick}>
            <Text translateKey="login" options={{ ns: TRANSLATION_NAMESPACE }} />
          </ActionButton>
          <ActionButton theme="primary" onClick={() => handleRegisterClick()}>
            <Text translateKey="create-account" options={{ ns: TRANSLATION_NAMESPACE }} />
          </ActionButton>
        </div>
      </div>
    </Modal>
  );
}

export default withRouter(LoginPromptModal);
